import React from 'react';

type LoginOptionsListProps = { children: React.ReactNode };

const LoginOptionsList = ({ children }: LoginOptionsListProps) => {
	return <ul className="vtex-login-2-x-optionsList optionsList list pa0">{children}</ul>;
};

export default LoginOptionsList;
